import { PageTitleHandler } from 'reservations/account/components/PageTitleHandler';
import { PageTitleHandlerV2 } from 'reservations/account/components/PageTitleHandlerV2';
import { AccessTokenProvider } from 'reservations/account/providers/AccessTokenProvider';
import { ConfigProvider } from 'reservations/account/providers/ConfigProvider';

type NextableProviderProps = {
  slug: string;
  children?: React.ReactNode;
  forAppRouter?: boolean;
};

const NextableProvider = ({
  slug,
  children,
  forAppRouter
}: NextableProviderProps) => {
  // this is a temporary meassurement, to be removed when changing all pages to use app routing
  // TODO: DMD-5737 - Remove conditional to leave V2 component
  const PageTitleHandlerComponent = forAppRouter
    ? PageTitleHandlerV2
    : PageTitleHandler;
  return (
    <AccessTokenProvider slug={slug}>
      <ConfigProvider>
        <PageTitleHandlerComponent>{children}</PageTitleHandlerComponent>
      </ConfigProvider>
    </AccessTokenProvider>
  );
};

export default NextableProvider;
